import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import getDefaultLoginUrl from '@/shared/helpers/getDefaultLoginUrl';
import Loader from './Loader';

// Index route target: sends `/` to the configured default_login_page instead of a fixed '/home'
const DefaultRedirect = () => {
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    getDefaultLoginUrl().then(setTarget);
  }, []);

  if (!target) return <Loader />;

  return <Navigate to={target} replace />;
};

export default DefaultRedirect;
